<template>
  <div>

    <div class="remodal modal modal__lineupProduct" :data-remodal-id="'modal-lineup-'+item.id"><button class="remodal-close" data-remodal-action="close"></button>
      <div class="modal__lineupProduct2col">
        <div class="modal__lineupProduct2colimg"><img :src="item.img.main" alt="" /></div>
        <div class="modal__lineupProduct2colTxt">
          <dl class="modal__lineupProduct2colTxtTop">
            <dt><span v-html="item.productName"></span></dt>
            <dd>
              <p>{{item.num}}</p>
              <table>
                <tr>
                  <th>ワイズ</th>
                  <td>{{item.wise}}</td>
                </tr>
                <tr>
                  <th>ヒール</th>
                  <td>{{item.heels}}</td>
                </tr>
                <tr>
                  <th>サイズ</th>
                  <td>{{item.size}}</td>
                </tr>
                <tr class="modal__lineupProduct2colTxtTop--color">
                  <th>カラー</th>
                  <td>
                    <ul class="lineup__colorTip">
                      <li v-for="col in item.color" :class="'lineup__colorTipLi lineup__colorTipLi--'+col"></li>
                    </ul>
                  </td>
                </tr>
              </table>
              <p class="modal__lineupProduct2colHosoku" v-if="item.hosoku">{{item.hosoku}}</p>
              <a v-on:click="click(item.id)" class="modal__lineupProductBtnCart btn-ga" target="_blank" :data-name="item.id" :href="item.url"></a>
            </dd>
          </dl>
          <dl class="modal__lineupProduct2colTxtBtm">
            <dt>足長・足囲チャート</dt>
            <dd>
              <table>
                <tr>
                  <th>サイズ</th>
                  <th>足長</th>
                  <th>足囲</th>
                </tr>
                <tr v-for="t in item.table">
                  <td>{{t[0]}}</td>
                  <td>{{t[1]}}</td>
                  <td>{{t[2]}}</td>
                </tr>
              </table>
            </dd>
          </dl>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ModalItem',
  // props: ['item'],
  props: ['item'],
  methods : {
    click : function(name){
      // let name = "ssssss";
      // // let name = $(this).data('name');
      let utm_campaign
      if (this.get_param('utm_campaign')) {
        utm_campaign = get_param('utm_campaign')
      } else {
        utm_campaign = "none"
      }
      // console.log("to GTM ->",name);
      // console.log(name,utm_campaign)
      ga('send', 'event', 'shoesBtn', name, utm_campaign)
    },
    get_param : function(name, url){
      if (!url) url = window.location.href;
      // console.log(url)
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      // console.log(results)
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
  }
  // props: {
  //   item: {
  //     type: Object,
  //   },
  // },
}

</script>




<style>
</style>
